<script setup lang="ts">
import { chartColors } from '@forgd/ui-kit/charts/lib/colors'
import type { DesignModel } from '@forgd/contract/types'
import type { WorkingGroup } from '#design-tokenomics/composables/useWorkingGroups'
import DtAdjustSellPressureTable from '#design-tokenomics/components/adjust/DtAdjustSellPressureTable.vue'
import { useWorkingGroups } from '#design-tokenomics/composables/useWorkingGroups'

type GroupWithColor = WorkingGroup & { color: string }

const model = defineModel<DesignModel>({ required: true })

const { groups } = useWorkingGroups(model)

const colorById = computed(() => {
  const ranked = [...groups.value].sort((a, b) =>
    a.allocationPercentage === b.allocationPercentage
      ? a.name.localeCompare(b.name)
      : b.allocationPercentage - a.allocationPercentage,
  )

  return new Map(
    ranked.map((group, index) => [
      group.id,
      chartColors.tokenDesigner[index % chartColors.tokenDesigner.length],
    ]),
  )
})

watchEffect(() => {
  for (const group of groups.value) {
    (group as GroupWithColor).color
      = colorById.value.get(group.id) ?? chartColors.tokenDesigner[0]!
  }
})

watch(
  groups,
  (next) => {
    for (const group of next) {
      group.impliedFdv = (group.costBasisTokens || 0) * model.value.MTS
    }
  },
  { deep: true, immediate: true },
)
</script>

<template>
  <DtAdjustSellPressureTable v-model="groups" />
</template>
